export const GET_USER_NETWORTH_START = 'GET_USER_NETWORTH_START';
export const GET_USER_NETWORTH_SUCCESS = 'GET_USER_NETWORTH_SUCCESS';
export const GET_USER_NETWORTH_ERROR = 'GET_USER_NETWORTH_ERROR';
export const GET_CURRENCY_NETWORTH_START =
  'GET_CURRENCY_NETWORTH_START';
export const GET_CURRENCY_NETWORTH_SUCCESS =
  'GET_CURRENCY_NETWORTH_SUCCESS';
export const GET_CURRENCY_NETWORTH_ERROR =
  'GET_CURRENCY_NETWORTH_ERROR';
